module.exports = {
  BASE_URL: "https://app.jala.tech",
  API_URL: "https://app.jala.tech/api",
  OAUTH2_URL: "https://app.jala.tech/oauth",
  JALA_CHAT_GPT_URL: "https://serverless.jala.tech/chat-gpt",
  CLIENT_ID: "10",
  CLIENT_SECRET: "Dmq39fRF0Vz6Xy5j0xea9IVx2YVEOH5vKeSU04yQ",

  MIXPANEL_TOKEN: "ee3737a6bb82261d4895f3ededc16665",
  INTERCOM_APP_ID: "dxwnmoek",
  INTERCOM_API_KEY: "android_sdk-5fb63bbb06a05a7d78e26631a54f13bd83648e2d",
  INTERCOM_SECRET_KEY: "HZYjg9bWfmVIv0x1DQmNGIR_BuX7jWy35R0LW9WH",
  INTERCOM_SECRET_KEY_WEB: "RPikvinQd6P_MisZ4et5HeOiFkauGGxz_LTLVOYa",
  POSTHOG_API_KEY: "phc_knUUjFhafk6dpzbQ356GmWPhkPY4GaY1rsNnQsoF5HK",

  SENTRY_DSN: "https://6169aedd1ba846e99f38019e30037730@o133133.ingest.sentry.io/5672526",
  SENTRY_DSN_WEB: "https://2dd666289b74438081f79597c1e316d0@o133133.ingest.sentry.io/4504504052416512",
  APPCENTER_DEPLOYMENT_KEY_ANDROID: "7yIM5Pm953FBfyY2X2oEVrS9NdvcDd62qGa1p",
  APPCENTER_DEPLOYMENT_KEY_IOS: "EYCvmr1cTBmu9SJnc3k01CbfCsunr24zEa9XF",
  APPCENTER_DISABLED: false,

  UXCAM_APP_KEY: '',

  AIRTABLE_BASE_ID: "appR8Vd9vSfrKdR6H",
  AIRTABLE_API_KEY: "key91MASmNzKfzBBj",
  AIRTABLE_FIELD: "tbl0CMwdqfptdxU4q",
  AIRTABLE_LEADERBOARD: "tbl5LToNq1Aj4iKYp"
}
